import React, { useEffect, useState } from 'react';
import { BsFilterRight } from 'react-icons/bs';
import { MdOutlineCloudDownload } from 'react-icons/md';

import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import { AppComponent } from '../../components/AppComponent/AppComponent';
import SorterButton from '../../components/SorterButton/SorterButton';
import { SorterEnum } from '../../utils/enumerators/Sorter.enum';
import { getPackageClientsMaster } from '../../utils/services/gitlab-service';
import { getDataByIdList } from '../../utils/services/service';
import PageDefault from '../PageDefault/PageDefault';

import './Versions.scss';

export default function Versions() {
	const [apiState, setApiState] = useState(true);
	const [clientsList, setClientsList] = useState([]);
	const [pesquisa, setPesquisa] = useState('');
	const [showSorterMenu, setShowSorterMenu] = useState(false);
	const [progress, setProgress] = useState(1);

	const [sorter, setSorter] = useState({
		type: SorterEnum.DATA,
		direction: 'desc',
	});

	useEffect(async () => {
		getClients();
	}, []);

	useEffect(() => {
		sorterClients();
	}, [sorter]);

	useEffect(() => {
		if (showSorterMenu) {
			window.onclick = function (event) {
				let classTarget = event.target.classList.toString();

				if (classTarget.indexOf('sort_button') < 0) {
					setShowSorterMenu(false);
				}
			};
		} else {
			window.onclick = null;
		}
	}, [showSorterMenu]);

	async function getClients(fromStore) {
		let clients = [];

		const allClientsMaster = await getPackageClientsMaster();
		const allClientsLength = allClientsMaster.length;

		const chunks = [];
		for (let i = 0; i < allClientsMaster.length; i += 10) {
			chunks.push(allClientsMaster.slice(i, i + 10));
		}

		let completed = 0;

		await Promise.all(
			chunks.map((chunk) =>
				getAppInfo(chunk, clients, fromStore).then(() => {
					completed += chunk.length;
					setProgress(Math.min(Math.floor((completed / allClientsLength) * 100), 99));
				})
			)
		);

		setProgress(100);

		setTimeout(() => {
			// Remove apps not available in google play
			clients = clients.filter((client) => client.url != null);

			clients = sorterClients(clients, sorter);

			setClientsList(clients);
		}, 1000);
	}

	async function getAppInfo(clientsToSearch, clients, fromStore) {
		let clientsPackageIdList = [];

		clientsToSearch.forEach((client) => {
			const appId = `${client.package}|${client.appleId}`;

			if (!clientsPackageIdList.includes(appId)) {
				clientsPackageIdList.push(appId);
				clients.push(client);
			}
		});

		let appDataListReq;

		try {
			appDataListReq = await getDataByIdList(clientsPackageIdList, fromStore);
		} catch {
			setApiState(false);
			return;
		}

		var appDataList = appDataListReq.data.filter((app) => /\d\.\d{2}\.\d{2}\.\d{3}/.test(app.version));

		clients.forEach((client) => {
			const appData = appDataList.find((app) => app.appId == client.package);

			if (appData != null) {
				client.version = appData.version;
				client.versionNumber = parseInt(appData.version.replace(/\D/g, ''));
				client.iosVersion = appData.iosVersion;
				client.iosVersionNumber = appData.iosVersion ? parseInt(appData.iosVersion.replace(/\D/g, '')) : null;
				client.name = appData.title;
				client.icon = appData.icon;
				client.url = appData.url;
				client.date = appData.updated;
				const dateUpdated = new Date(appData.updated);
				client.updateDate = `${String(dateUpdated.getDate()).padStart(2, '0')}/${String(dateUpdated.getUTCMonth() + 1).padStart(2, '0')}/${dateUpdated.getFullYear()}`;
			}
		});
	}

	function sync() {
		setPesquisa('');
		setProgress(1);
		setClientsList([]);
		getClients(true);
	}

	function changeSorter(newSorter) {
		setSorter({
			type: newSorter,
			direction: sorter.type == newSorter ? (sorter.direction == 'asc' ? 'desc' : 'asc') : 'desc',
		});
	}

	function sorterClients(clientListParam, newSorter) {
		let list = clientListParam || clientsList;
		let attribute;

		if (!newSorter) {
			newSorter = sorter;
		}
		if (newSorter.type === SorterEnum.NOME) {
			attribute = 'name';
		}
		if (newSorter.type === SorterEnum.DATA) {
			attribute = 'date';
		}
		if (newSorter.type === SorterEnum.VERSAO) {
			attribute = 'versionNumber';
		}
		list = list.sort((a, b) => {
			if (a[attribute] < b[attribute]) {
				return newSorter.direction == 'asc' ? -1 : 1;
			}
			if (a[attribute] > b[attribute]) {
				return newSorter.direction == 'asc' ? 1 : -1;
			}
			return 0;
		});

		if (!clientListParam) {
			setClientsList([]);
			setTimeout(() => {
				setClientsList(list);
			}, 1);
		}

		return list;
	}

	function filterClients(client) {
		return (
			pesquisa == '' ||
			client.package.toUpperCase().includes(pesquisa.toUpperCase()) ||
			client.name.toUpperCase().includes(pesquisa.toUpperCase()) ||
			client.version.toUpperCase().includes(pesquisa.toUpperCase())
		);
	}

	return (
		<PageDefault>
			<div className="versions">
				{apiState && (
					<>
						{clientsList.length == 0 && (
							<div className="centered loading">
								<span>Buscando versões de todos os aplicativos nas lojas...</span>
								<span>Isso pode levar até 1 minuto</span>
								<Box
									className="progress"
									sx={{ width: '300px' }}>
									<LinearProgress
										variant="determinate"
										value={progress}
									/>
								</Box>
							</div>
						)}

						{!apiState && (
							<div className="centered">
								<span>Houve um erro na busca de informações nas lojas.</span>
							</div>
						)}

						{clientsList.length > 0 && (
							<div className="container">
								<div
									className="header"
									key="TESTE">
									<div className="search">
										<input
											placeholder="Pesquise pelo nome, pacote ou versão..."
											value={pesquisa}
											type="search"
											onChange={(e) => setPesquisa(e.target.value)}
										/>

										<div className="dropdown">
											<BsFilterRight
												title="Ordenar"
												className="sorter_menu"
												onClick={() => setShowSorterMenu(true)}
											/>
											{showSorterMenu && (
												<div className="dropdown-content">
													<SorterButton
														activeSorter={sorter}
														type={SorterEnum.NOME}
														label="Nome"
														changeSorter={changeSorter}
													/>

													<SorterButton
														activeSorter={sorter}
														type={SorterEnum.DATA}
														label="Data"
														changeSorter={changeSorter}
													/>

													<SorterButton
														activeSorter={sorter}
														type={SorterEnum.VERSAO}
														label="Versão"
														changeSorter={changeSorter}
													/>
												</div>
											)}
										</div>

										<MdOutlineCloudDownload
											className="refresh"
											title="Sincronizar novamente"
											onClick={sync}
										/>
									</div>
								</div>

								<div className="app-list">
									{clientsList.filter(filterClients).map((client, index) => (
										<div className="app-container">
											<AppComponent
												client={client}
												key={`app_${index}_${client.package}`}
											/>
										</div>
									))}
								</div>
							</div>
						)}
					</>
				)}
			</div>
		</PageDefault>
	);
}
